import { render, staticRenderFns } from "./Brothers.vue?vue&type=template&id=09ad246d&"
import script from "./Brothers.vue?vue&type=script&lang=js&"
export * from "./Brothers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports